import React, { useEffect, useState, useRef } from 'react'
import { Box, Typography } from '@mui/material'
import { MuiSelect, MuiButton } from '../../../../../components'
import { getSnapshotUpdatedJson_AddRowColFunc } from '../../../../../util'
import { IconTrashAdvSearch, IconDrag  } from '../../../../../assets/images/icons'
import { OuterWrapper, Wrapper, Title, DragButton, InnerWrapper, DeleteWrapper } from './style'

const AddWidget = ({ data, index, onChange, onDelete, widgetArray, setWidgetArray, draggedItem, setDraggedItem }) => {
    const [defaultWidth, setDefaultWidth] = useState(data?.width || 1)
    const [defaultHeight, setDefaultHeight] = useState(data?.height || 1)
    const widthArray = [{label:'Width 1x', value:1}, {label:'Width 2x', value:2}, {label:'Width 3x', value:3}, {label:'Width 4x', value:4}]
    const heightArray = [{label:'Height 1x', value:1}, {label:'Height 2x', value:2}, {label:'Height 3x', value:3}]

    const onWidthChange = (e) => {
        setDefaultWidth(e)
        onChange({...data, width:e})
    }

    const onHeightChange = (e) => {
        setDefaultHeight(e)
        onChange({...data, height:e})
    }

    const styles = { height: data.h, width: data.w, outline: '0px blue solid'}
    styles.gridRowStart = data.gridRowStart
    if (data.rowspan) { styles.gridRowEnd = `span ${data.rowspan}` }
    styles.gridColumnStart = data.gridColumnStart
    if (data.colSpan) { styles.gridColumnEnd = `span ${data.colSpan}` }

    const ref = useRef(null)
    const handleDragStart = (index) => {
        setDraggedItem(index)
    };
    const handleDragOver = (event) => {
        event.preventDefault();
    };
    const handleDrop = (index) => {
        if (draggedItem !== null && draggedItem !== index) {
            const newItems = [...widgetArray];
            const [movedItem] = newItems.splice(draggedItem, 1); // Remove dragged item
            newItems.splice(index, 0, movedItem); // Insert at dropped position
            const newItemsNew = newItems.map((d, i) => ({...d, orderBy:i}))

            const array = getSnapshotUpdatedJson_AddRowColFunc(newItemsNew)
            setWidgetArray(array);
            setDraggedItem(null);
        }
    }

    return (
        <OuterWrapper
            ref={ref}
            data-title={data.textContent}
            className={`${data.className} grid-item`}
            style={styles}

            // draggable
            // onDragStart={() => handleDragStart(data.orderBy)}
            onDragOver={handleDragOver}
            onDrop={() => handleDrop(data.orderBy)}
        >
            <Wrapper index={data.id-1}>
                <Title>{data.title}</Title>
                <DragButton draggable onDragStart={() => handleDragStart(data.orderBy)}><IconDrag /></DragButton>

                <InnerWrapper>
                    <MuiSelect
                        name={'selectWidth'}
                        styletype='themeV2'
                        onChange={(e) => onWidthChange(e.target.value)}
                        data={widthArray}
                        compact
                        value={defaultWidth}
                    />
                    <MuiSelect
                        name={'selectHeight'}
                        styletype='themeV2'
                        onChange={(e) => onHeightChange(e.target.value)}
                        data={heightArray}
                        compact
                        value={defaultHeight}
                    />
                </InnerWrapper>
                <MuiButton variant='text' color='error' size='small' startIcon={<IconTrashAdvSearch />} className='deleteButton' onClick={() => onDelete(data) } />
            </Wrapper>
        </OuterWrapper>
    )
}

export default AddWidget
